import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import moment from 'moment'
import 'moment/locale/pl'
import { useTranslation } from 'react-i18next'
import MonthWeekRow from './MonthWeekRow'

function MonthView({ trainings, startDate }) {
	const navigate = useNavigate()
	const { i18n } = useTranslation()
	const isPolish = (i18n.resolvedLanguage || i18n.language || 'en').startsWith('pl')
	const monthStart = moment(startDate).startOf('month')
	const monthEnd = moment(startDate).endOf('month')
	const calendarStart = moment(monthStart).startOf('isoWeek')
	const calendarEnd = moment(monthEnd).endOf('isoWeek')
	const weekdayHeaders = isPolish
		? ['pon', 'wt', 'śr', 'czw', 'pt', 'sob', 'niedz']
		: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']

	const days = []
	let currentDay = moment(calendarStart)
	while (currentDay.isSameOrBefore(calendarEnd)) {
		days.push({
			date: currentDay.format('YYYY-MM-DD'),
			day: currentDay.date(),
			isCurrentMonth: currentDay.month() === monthStart.month(),
		})
		currentDay.add(1, 'day')
	}

	const weeks = []
	for (let i = 0; i < days.length; i += 7) {
		weeks.push(days.slice(i, i + 7))
	}

	const handleTrainingClick = useCallback(
		item => {
			const trainingId = item?._id || item?.id
			if (!trainingId) return
			navigate(`/centrumSzkolen/szkolenia/details/${trainingId}`)
		},
		[navigate]
	)

	return (
		<div className="max-w-full rounded-lg border border-gray-200 bg-white shadow-sm">
			<div className="overflow-x-auto">
				<div className="min-w-[720px] lg:min-w-0">
					<div className="grid grid-cols-7 border-b border-gray-200">
						{weekdayHeaders.map(day => (
							<div
								key={day}
								className="border-r border-gray-200 bg-gray-50 px-4 py-3 text-center text-sm font-semibold text-gray-900 last:border-r-0">
								{day}
							</div>
						))}
					</div>

					<div className="divide-y divide-gray-200">
						{weeks.map((week, weekIndex) => (
							<MonthWeekRow
								key={weekIndex}
								week={week}
								trainings={trainings}
								onTrainingClick={handleTrainingClick}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	)
}

export default MonthView
